import { create } from 'zustand';

type BizySidePanelView = 'chat' | 'history' | 'settings';

export type BizyPanelTrigger = 'auto' | 'user' | 'keyboard' | 'navbar_restore' | 'navbar_collapse' | (string & {});

export type BizySupportMode = 'bizy' | 'fin' | 'human_agent';

export interface BizySupportContext {
	summary?: string;
	category?: string;
	finConversationId?: string;
}

export const BIZY_PANEL_DEFAULT_WIDTH = 352;
export const BIZY_PANEL_MIN_WIDTH = 280;
export const BIZY_PANEL_MAX_WIDTH = 560;

interface BizySidePanelStore {
	isOpen: boolean;
	lastTrigger: BizyPanelTrigger | null;
	view: BizySidePanelView;
	width: number;
	isResizing: boolean;
	supportMode: BizySupportMode;
	supportContext: BizySupportContext;
	open: (trigger?: BizyPanelTrigger) => void;
	close: (trigger?: BizyPanelTrigger) => void;
	toggle: (trigger?: BizyPanelTrigger) => void;
	showChat: () => void;
	showHistory: () => void;
	showSettings: () => void;
	setWidth: (width: number) => void;
	setIsResizing: (isResizing: boolean) => void;
	setSupportMode: (mode: BizySupportMode) => void;
	setSupportContext: (context: BizySupportContext) => void;
	resetSupport: () => void;
}

export const useBizySidePanelStore = create<BizySidePanelStore>((set) => ({
	isOpen: false,
	lastTrigger: null,
	view: 'chat',
	width: BIZY_PANEL_DEFAULT_WIDTH,
	isResizing: false,
	supportMode: 'bizy',
	supportContext: {},
	open: (trigger) => set({ isOpen: true, lastTrigger: trigger ?? 'user' }),
	close: (trigger) => set({ isOpen: false, lastTrigger: trigger ?? 'user' }),
	toggle: (trigger) => set((state) => ({ isOpen: !state.isOpen, lastTrigger: trigger ?? 'user' })),
	showChat: () => set({ view: 'chat' }),
	showHistory: () => set({ view: 'history' }),
	showSettings: () => set({ view: 'settings' }),
	setWidth: (width) => set({ width: Math.max(BIZY_PANEL_MIN_WIDTH, Math.min(BIZY_PANEL_MAX_WIDTH, width)) }),
	setIsResizing: (isResizing) => set({ isResizing }),
	setSupportMode: (supportMode) => set({ supportMode }),
	setSupportContext: (supportContext) => set({ supportContext }),
	resetSupport: () => set({ supportMode: 'bizy', supportContext: {} }),
}));
